/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import kitsu from '@plugins/kitsu';
import { queryString } from '@utils/format';
let $ajax;

export const state = {
  configs: null,
  wktOnline: null,
  statistik: null,
  api: null,
};

export const mutations = {
  SET_CONFIG(state, newValue) {
    state.configs = newValue;
  },
  SET_ONLINE(state, newValue) {
    state.wktOnline = newValue;
  },
  SET_STATISTIK(state, newValue) {
    state.statistik = newValue;
  },
  SET_API(state, newValue) {
    state.api = newValue;
  },
};

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${payload.attr.api}/simulasi`,
    });
    return await $ajax.get('/', { params: payload.params });
  },

  async getDetail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${payload.api}/simulasi/${payload.id}`,
    });

    return await $ajax.get('/', { params: payload.params });
  },

  create({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/i/${id}/${payload.api}/wawancara/${payload.id}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  update({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/${payload.api}/simulasi/update-nilai/${payload.id}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  delete({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/${payload.api}/asesor-nilai/rekomendasi-delete/${payload}`;
    return http.post(url).then(({ data }) => data);
  },

  action({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/${payload.api}/wawancara/${payload.name}/${payload.id}`;
    return http[payload.method](url, payload.params).then(({ data }) => data);
  },

  createJadwal({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/${payload.api}/wawancara/jadwal-create`;
    return http.get(url).then(({ data }) => data);
  },

  updateSlot({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/${payload.api}/simulasi/update`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  nilai({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/${payload.api}/asesor-nilai/simulasiajar-update/${payload.id}${
      payload && payload.query ? '?' + queryString(payload.query) : ''
    }`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  slot({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${payload.api}/simulasi/${payload.tipe}`,
    });

    return $ajax.get('/', { params: payload.params }).then(({ data }) => data);
  },

  reschedule({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/${payload.api}/simulasi-ajar/jadwal-ulang/${payload.id}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  async konfig({ rootState, commit }, payload) {
    const id = rootState.auth.instansi_id;
    const resp = await http.get(`psp/i/${id}/${payload.api}/simulasi/config?${queryString(payload.config)}`);

    const wkt_online = resp && resp.headers && resp.headers.date;
    commit('SET_ONLINE', new Date(wkt_online).toLocaleString('en-US', { timeZone: 'Asia/Jakarta' }));
    commit('SET_CONFIG', resp && resp.data.data);
    commit('SET_API', payload.api);
  },

  async getStatistik({ rootState, commit }, payload) {
    const id = rootState.auth.instansi_id;
    const resp = await http
      .get(`psp/i/${id}/${payload.api}/simulasi/statistik?${queryString(payload.params)}`)
      .then(({ data }) => data);

    commit('SET_STATISTIK', resp && resp.data);
    return resp;
  },

  async getAsesor({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${payload.api}/simulasi/asesors`,
    });

    return await $ajax.get('/', { params: payload.params }).then(({ data }) => data);
  },

  unduhKinerja({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/${
      payload.api
    }/asesor-kinerja/simulasi-ajar/download?${queryString(payload)}`;
    return Promise.resolve(url);
  },

  setGmeet({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/${payload.api}/simulasi/update-link`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  downloadList({ rootState, state }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/${state.api}/simulasi/download/${payload.url}?${queryString(
      payload.params
    )}`;
    return Promise.resolve(url);
  },
};
